import React from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { notification, Space } from 'antd';
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { Loading } from '../../../../../base-react/components/Loading';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var CheckinSource = models.checkins.CheckinSource;
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import { DeleteOutlined, ImportOutlined, UndoOutlined } from '@ant-design/icons';
export const CheckinToolbar = (props) => {
    const { competition, disabled } = props;
    const [reports, loadingReports] = Stream(competition ? CheckinSource(competition.competition_id) : undefined);
    if (loadingReports) {
        return React.createElement(Loading, null);
    }
    const canApply = reports && reports.filter(function (report) {
        return report.applied_at == null && report.checkin_time != null;
    }).length > 0;
    const canUnapply = reports && reports.filter(function (report) {
        return report.applied_at != null;
    }).length > 0;
    const onCommand = async (command, done) => {
        let redirectCommand = command;
        switch (command) {
            case 'reset':
                {
                    redirectCommand = 'unapply';
                }
                break;
            case 'delete':
                {
                    redirectCommand = 'reset';
                }
                break;
        }
        await Api.call(CheckinSource(competition === null || competition === void 0 ? void 0 : competition.competition_id).url, redirectCommand, {})
            .then(() => {
            notification.success({
                message: _T(`common.${command}.success`, { name: _T('checkin.title').toLowerCase() })
            });
        })
            .catch((err) => {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
        done();
    };
    return (React.createElement(Space, null,
        React.createElement(ButtonConfirm, { title: _T('common.import.title', { name: _T('checkin.title').toLowerCase() }), description: _T('common.import.content', { name: _T('checkin.title').toLowerCase() }), onConfirm: (done) => onCommand('apply', done), buttonProps: {
                size: 'large',
                type: 'primary',
                disabled: !canApply || disabled,
                icon: React.createElement(ImportOutlined, null)
            } }),
        React.createElement(ButtonConfirm, { title: _T('common.reset.title', { name: _T('checkin.title').toLowerCase() }), description: _T('common.reset.content', { name: _T('checkin.title').toLowerCase() }), onConfirm: (done) => onCommand('reset', done), buttonProps: {
                size: 'large',
                type: 'dashed',
                disabled: !canUnapply || disabled,
                icon: React.createElement(UndoOutlined, null)
            } }),
        React.createElement(ButtonConfirm, { title: _T('common.delete.title', { name: _T('checkin.signatures').toLowerCase() }), description: _T('common.delete.content', { name: _T('checkin.signatures').toLowerCase() }), onConfirm: (done) => onCommand('delete', done), buttonProps: {
                size: 'large',
                danger: true,
                disabled: !canUnapply || disabled,
                icon: React.createElement(DeleteOutlined, null)
            } })));
};
